module.exports = __webpack_public_path__ + "img/circle.b19bb81a.svg";